import axios from 'axios';
import MainURL from '../../../MainURL';

export type AiSermonType = 'summary' | 'qt' | 'groupShare' | 'praiseThemes';

// 설교지원 페이지에서 한 번에 생성되는 순서와 동일 (그룹 카드 탭 순서 기준으로도 사용)
export const AI_SERMON_TYPE_ORDER: AiSermonType[] = ['summary', 'qt', 'groupShare', 'praiseThemes'];

export const AI_SERMON_PREVIEW_LENGTH = 120;

export const AI_SERMON_TYPE_LABELS: Record<AiSermonType, string> = {
  summary: '설교 요약',
  qt: 'QT',
  groupShare: '소그룹 나눔지',
  praiseThemes: 'AI 찬양추천',
};

export type AiSermonItem = {
  id: number;
  type: AiSermonType;
  resultContent: string;
  createdAt: string;
  groupId: string | null;
};

export async function fetchAiSermonList(userAccount: string): Promise<AiSermonItem[]> {
  if (!userAccount) return [];
  const res = await axios.get(`${MainURL}/mypage/getaisermonlist/${encodeURIComponent(userAccount)}`);
  return Array.isArray(res.data) ? (res.data as AiSermonItem[]) : [];
}

export async function deleteAiSermonItem(id: number, userAccount: string): Promise<boolean> {
  const res = await axios.post(`${MainURL}/mypage/deleteaisermon`, { id, userAccount });
  return res.data === true;
}

export function formatAiSermonDate(value: string): { date: string; time: string } {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { date: '-', time: '' };
  return {
    date: d.toLocaleDateString('ko-KR', { year: 'numeric', month: 'numeric', day: 'numeric' }),
    time: d.toLocaleTimeString('ko-KR', { hour: 'numeric', minute: '2-digit' }),
  };
}
